require('flickity')

// Related content
try {
  $('.carousel').each(function() {
    var flky = new Flickity( this, {
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      watchCSS: true,
      resize: true
    })
  })

} catch (error) {
  console.error(error)
}
